import type { Config } from '@puckeditor/core';

import { buttonConfig } from './button';
import { flexLayoutConfig } from './flex-layout';
import { headingConfig } from './heading';
import { heroConfig } from './hero';
import { imageConfig } from './image';
import { paragraphConfig } from './paragraph';
import { productCarouselConfig } from './product-carousel/product-carousel';
import { sectionConfig } from './section';
import { spacerConfig } from './spacer';

type Components = NonNullable<Config['components']>;

/**
 * Generic page-building blocks, usable by any CMS model. A model opts in by
 * spreading this whole map into its Puck config, or by picking the entries it
 * wants — nothing here assumes a particular model.
 */
export const PAGE_BLOCKS: Components = {
  Hero: heroConfig,
  Section: sectionConfig,
  FlexLayout: flexLayoutConfig,
  Spacer: spacerConfig,
  Heading: headingConfig,
  Paragraph: paragraphConfig,
  Image: imageConfig,
  Button: buttonConfig,
};

/**
 * Blocks that render the merchant's catalog. Kept out of PAGE_BLOCKS because they need
 * a resolved dispensary, whereas everything in PAGE_BLOCKS renders from its own props
 * alone — a model should be able to take the generic blocks without the commerce ones.
 */
export const COMMERCE_BLOCKS: Components = {
  ProductCarousel: productCarouselConfig,
};

/** Commerce-category block names, in the order they should appear in the panel. */
export const COMMERCE_BLOCK_NAMES = ['ProductCarousel'];

/** Layout-category block names, in the order they should appear in the panel. */
export const PAGE_LAYOUT_BLOCK_NAMES = ['Hero', 'Section', 'FlexLayout', 'Spacer'];

/** Content-category block names, in the order they should appear in the panel. */
export const PAGE_CONTENT_BLOCK_NAMES = ['Heading', 'Paragraph', 'Image', 'Button'];
